import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import ProjectForm from '../project-form';
import { GetProjectsUsersAndGroups } from '../../../../../services/api/project-api';
import { GetProjectNEWAPI } from '../../../../../services/api/project-api';
import { GetAllProjectTemplatesForProjectsAPI } from '../../../../../services/api/project-template-api';
import { buildEditMemberSelection } from '../helpers/project-helpers';

function ProjectEdit() {
    const location = useLocation();
    const [initialProject, setInitialProject] = useState(null);

    useEffect(() => {
        const fetchProject = async () => {
            let projectId = location.pathname.split("/")[3];
            const result = await GetProjectNEWAPI(projectId);
            let project = result.data;
            project.Start = new Date(project.Start);
            project.End = new Date(project.End);

            const usersAndGroups = await GetProjectsUsersAndGroups();
            const { allUsers, members } = buildEditMemberSelection(
                project,
                usersAndGroups?.data.UserMembers,
                usersAndGroups?.data.GroupMembers
            );
            project.allUsers = allUsers;
            project.Members = members;
            const projectTemplatesResult = await GetAllProjectTemplatesForProjectsAPI();
            
            if (projectTemplatesResult.data !== null) {
                project.Templates = projectTemplatesResult?.data?.map(template => ({ 
                    value: template.Id, 
                    text: template.ProjectType, 
                    duration: template.Days,
                    isMultiOwner: template.IsMultiOwner ?? false,
                    members: template.Members || [],
                    owners: template.Owners || [],
                }));
            } else {
                project.Templates = [];
            }

            setInitialProject(project);
        };
        fetchProject();
    }, []);

    return (
        initialProject ? <ProjectForm isEdit={true} initialProject={initialProject} /> : <div>Loading...</div>
    );
}

export default ProjectEdit;
